import React, { } from 'react'
import { Box, Typography } from '@material-ui/core';

import { useTheme } from '@material-ui/core/styles';
import { CustomTinyButton } from '../../common/CustomComponents';
import { useCalculator, DISPATCH_RESET_SALARY } from '../../../state/calculatorState';
import { useLayout, RESET, EXPAND_ALL_INPUT } from '../../../state/layoutState';
import { compileOptions } from '../../../utils/utils'
import { NBSP } from '../../../constants'

export const ToggleOptions = (props) => {
    const theme = useTheme();
    const [calculator, dispatchCalculator] = useCalculator();
    const [{
        expandInput_Superannuation,
        expandInput_NovatedLease,
        expandInput_FringeBenefits,
        expandInput_TaxCategory,
        expandInput_MedicareOffsets,
        expandInput_Deductions,
        expandInput_FamilyBenefits,
    }, dispatchLayout] = useLayout();

    const options = compileOptions(calculator);
    const optionsLabels = options.map(o => o[0]);

    const handleExpandAll = () => {
        return (
            dispatchLayout({
                type: EXPAND_ALL_INPUT,
                expanded: true,
            })
        )
    }

    const handleCollapseAll = () => {
        return (
            dispatchLayout({
                type: EXPAND_ALL_INPUT,
                expanded: false,
            })
        )
    }

    const handleReset = (e) => {
        e.stopPropagation();
        return (
            dispatchCalculator({
                type: DISPATCH_RESET_SALARY,
                data: 0,
            }),
            dispatchLayout({
                type: RESET,
                data: 0,
            })
        )
    }


    if (props.hidden) {
        return null;
    }

    const defaultState = optionsLabels && optionsLabels.length === 0 ? true : false
    const showingOptions = expandInput_Superannuation || expandInput_NovatedLease || expandInput_FringeBenefits || expandInput_TaxCategory || expandInput_MedicareOffsets || expandInput_FamilyBenefits || expandInput_Deductions;

    let label = showingOptions ? "Hide All Settings" : ""

    return (
        <Box style={{ paddingBottom: 10 }}>
            

                <Box display="flex" justifyContent="space-between" flex='1' style={{ paddingTop: 5 }}>
                
           
                    <Box display="flex" justifyContent="flex-start" >
                    {showingOptions && (
                        <CustomTinyButton
                            tabIndex="-1"
                            variant="contained"
                            style={{ marginRight: 30, backgroundColor: showingOptions ? theme.palette.primary.light : theme.palette.background.paper }}
                            onClick={showingOptions ? handleCollapseAll : handleExpandAll} >
                            {label}
                        </CustomTinyButton>
                        )}
                    </Box>
             
                    {!defaultState && (
                        <Box style={{ paddingTop: 10, paddingBottom: 0, paddingRight: 5, paddingLeft: 0 }} display="flex" flexDirection="row" justifyContent="center">
                            <Typography variant='body2' style={{ paddingRight: 5, lineHeight: 0.9, fontWeight: 700, color: theme.palette.secondary.main }}>{defaultState ? NBSP : `Options include:`}</Typography>
                            <Typography variant='body2' style={{ lineHeight: 0.9, color: theme.palette.primary.contrastText }}>
                                {optionsLabels.join(', ')}
                            </Typography>
                        </Box>
                    )}

                    <CustomTinyButton tabIndex="-1" variant="contained" style={defaultState ? {} : { backgroundColor: theme.palette.secondary.light }} disabled={defaultState} onClick={handleReset} >Reset settings</CustomTinyButton>
                </Box>

   
        </Box>
    )
}

export default ToggleOptions;
